export default __webpack_public_path__ + "static/media/events.7947520c.png";